import { EarnedBadge } from '@account/types';
import { ActionCard, ActionCardProps } from '@components/display/cards';
import { DefaultBadge } from '@levelSystem/components/badges';
import { Chip, Typography } from '@mui/material';
import { capitalizeFirstLetter } from '@utils/common';
import { format } from 'date-fns';

type BadgeActionCardProps = Omit<ActionCardProps, 'img' | 'avatar' | 'typographyElements' | 'chips'> & {
    badge: EarnedBadge;
};

export const BadgeActionCard = ({ badge, ...props }: BadgeActionCardProps) => (
    <ActionCard
        key={badge.id}
        className="min-w-0 w-auto flex-[0_0_calc(233px)]"
        {...props}
        img={
            badge.level_badge.image ? (
                <img src={badge.level_badge.image} />
            ) : (
                <DefaultBadge
                    className="!size-24"
                    level={badge.level_badge.level.value}
                    badgeCoreProps={{
                        className: '!size-12',
                    }}
                />
            )
        }
        typographyElements={[
            <Typography fontWeight={500}>{capitalizeFirstLetter(badge.level_badge.level.name)} Level</Typography>,
            <Typography color="neutral-600" fontSize={12} fontWeight={500}>
                {format(badge.awarded_at, 'dd/MM/yyyy')}
            </Typography>,
        ]}
        chips={[
            <Chip
                className="blue-gradient"
                label={
                    <Typography fontSize={12} fontWeight={500} color="white.main">
                        {capitalizeFirstLetter(badge.level_badge.badge.name)}
                    </Typography>
                }
                size="small"
            />,
        ]}
    />
);
